module.exports = __webpack_public_path__ + "img/logo-kiratik.ab566d50.png";